exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".user-avatar {\n  display: inline-flex;\n  align-items: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/app_bar_user_profile/user_avatar/user_avatar.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/components/app_bar_user_profile/user_avatar/user_avatar.scss
// module chunks = index